export const literaryDevicesPool = [
    {
      line: "The wind whispered through the trees.",
      device: "Personification",
      distractors: ["Metaphor", "Simile", "Alliteration"]
    },
    {
      line: "Her eyes were diamonds shining in the night.",
      device: "Metaphor",
      distractors: ["Simile", "Hyperbole", "Alliteration"]
    },
    {
      line: "He was as brave as a lion.",
      device: "Simile",
      distractors: ["Metaphor", "Personification", "Onomatopoeia"]
    },
    {
      line: "Boom! The thunder shook the house.",
      device: "Onomatopoeia",
      distractors: ["Metaphor", "Alliteration", "Simile"]
    }
    // ...add more!
  ];
  